import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { ToastMessage, ToastContainer } from 'react-toastr';

import 'animate.css/animate.css';
import 'toastr/build/toastr.css';

import { setNotification } from '../reducers/notification';

const ToastMessageFactory = React.createFactory(ToastMessage.animation);

const mapStateToProps = state => ({
  notificationText: state.notification.text
});

const mapDispatchToProps = dispatch => ({
  clearText: () => dispatch(setNotification(''))
});

class NotificationComponent extends Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.notificationText !== '') {
      this.container.success(nextProps.notificationText);
      if (nextProps.notificationText === 'Palvelimeen ei saada yhteyttä.') {
        this.container.error(nextProps.notificationText);
      }
      this.props.clearText();
    }
  }

  shouldComponentUpdate() {
    return false; // Prevent creating ToastContainer more than once
  }

  render() {
    return (
      <ToastContainer
        ref={(c) => { this.container = c; }}
        toastMessageFactory={ToastMessageFactory}
        className="toast-top-center"
      />
    );
  }
}

NotificationComponent.propTypes = {
  notificationText: PropTypes.string.isRequired,
  clearText: PropTypes.func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationComponent);



// WEBPACK FOOTER //
// ./src/components/NotificationComponent.jsx